<template>
    <div class="w-8"></div>
    <div class="ds-exchange-row-text ds-exchange-col-date">
        <div>{{ date }}</div>
        <div class="ds-exchange-row-secondary">{{ startTime }} - {{ endTime }}</div>
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-position">
        {{ incomeRequest ? 'Входящий запрос' :  'Исходящий запрос'}}
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-department" v-if="incomeRequest">
        {{ department }}
    </div>
    <div class="ds-exchange-row-text ds-exchange-col-department" v-else>
        {{ requestedDepartment }}
    </div>
    <div class="ds-exchange-col-status">
       <RequestStatus :status />
    </div>
    <div class="relative ds-exchange-col-employee">
        <div v-if="assigned">
            <User :first-name="assigned.first_name" :last-name="assigned.last_name" :avatar="assigned.avatar" :subtitle="assigned.position?.name" exchange />
        </div>
        <div v-else class="flex">
            <RequestedUser :user="requestedUser" :vacancy-id="request.id" :income="incomeRequest" :rejected="isRejected" />
        </div>
    </div>
    
</template>

<script setup lang="ts">
interface Props {
    request: any
}
import { computed } from 'vue'
import dayjs from 'dayjs'
import { useAuthStore } from '@/stores/authStore';
import User from '../User.vue';
import RequestStatus from './RequestStatus.vue';
import RequestedUser from './RequestedUser.vue';
const { request } = defineProps<Props>()
const emit = defineEmits(['user'])
const store = useAuthStore()

const date = computed(() => dayjs(request.dttm_work_start_at).format('DD.MM.YYYY'))
const startTime = computed(() => dayjs(request.dttm_work_start_at).format('HH:mm'))
const endTime = computed(() => dayjs(request.dttm_work_end_at).format('HH:mm'))
// const position = computed(() => request.position.name)
const department = computed(() => request.department.name)
const requestedUser = computed(() => request.requested_user)
const requestedDepartment = computed(() => request.requested_department.name)
const assigned = computed(() => request.assigned_user)
const incomeRequest  = computed(() => store.userInfo.department.name === request.requested_department.name)
const isRejected = computed(() => request.is_request_rejected)
const status = computed(() => {
    if(isRejected.value) return 'rejected'
    return request.status
})
</script>
